/**
 * @fileoverview Konfigurationsmodul für die Anwendung.
 *
 * Dieses Modul bietet zentralisierte Konfigurationsverwaltung mit:
 * - Laufzeit-Validierung mittels Zod Schemas
 * - Singleton Config Injection Token
 * - Abhängigkeit von ServiceModule für Initialisierung
 *
 * Das Config Token kann in jeden Service oder jede Component injiziert werden
 * um auf validierte Anwendungskonfiguration zuzugreifen.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Config, ConfigService } from './service/config.service';
import { ServiceModule } from './service/service.module';

/**
 * Konfigurationsmodul für die Anwendung.
 *
 * Importiert ServiceModule um sicherzustellen dass Konfiguration während App-Initialisierung geladen wird,
 * und stellt das Config Injection Token für Zugriff auf validierte Konfiguration bereit.
 *
 * Verwendung:
 * ```typescript
 * constructor(@Inject(Config) private config: IConfig) {
 *   const apiUrl = config.chatbot.apiBaseUrl;
 * }
 * ```
 *
 * @class ConfigModule
 */
@NgModule({
  declarations: [],
  imports: [CommonModule, ServiceModule],
  providers: [
    {
      provide: Config,
      useFactory: (configService: ConfigService) => configService.config,
      deps: [ConfigService],
    },
  ],
})
export class ConfigModule {}
